












































































import { Component, Prop, Vue } from 'vue-property-decorator';
import { MarkerInfoWindow, MarkerType } from '@/types/extendedMapOptions';
import { RouteStop } from '@/api/types';
import { toLocalDateFormatted } from '@/common/utils/date';
import { getStreetViewUrl, getStreetViewPreviewImageUrl } from '@/common/utils/googleMaps';

@Component
export default class GoogleMapInfoWindow extends Vue {
  @Prop({ required: true })
  markerInfoWindow!: MarkerInfoWindow;

  get isRoutStop(): boolean {
    return this.markerInfoWindow.type === MarkerType.routeStop;
  }

  private getStreetViewUrl(routeStop: RouteStop): string {
    return getStreetViewUrl(routeStop?.entranceLocation, routeStop?.location);
  }

  private getStreetViewPreviewImageUrl(routeStop: RouteStop): string {
    return getStreetViewPreviewImageUrl(routeStop?.entranceLocation, routeStop?.location);
  }

  private formatDate(date: Date): string {
    return !date ? 'NOT AVAILABLE' : toLocalDateFormatted(date, 'DD MMM YYYY, hh:mm A');
  }

  private closeInfoWindow(): void {
    this.$emit('closeInfoWindow', null);
  }
}
